import React from 'react'

function AboutPhilosophyStrip() {
    const pillars = [
        {
            title: 'Specialize or Don\'t Bother.',
            text: 'We work in four areas. Not fourteen. Healthcare billing requires a much deeper level of knowledge than general bookkeeping. Cybersecurity is not the same as basic IT support. Long-form content is not the same as social media copy. We chose to go deep in fewer areas rather than shallow across many—and our clients benefit from that discipline every day.',
            icon: 'fas fa-layer-group',
        },
        {
            title: 'Honesty Over the Easy Answer',
            text: "We'll tell you when outsourcing isn't the right move for your situation. We'll flag a problem before you discover it yourself. We'll give you a realistic timeline instead of whatever gets the contract signed fastest. That approach costs us the occasional quick win. It's also why more than 95 percent of our clients are still with us.",
            icon: 'fas fa-handshake',
        },
        {
            title: 'Your Success Is The Only Metric That Matters.',
            text: "We don't measure performance by how many clients we sign. We measure it by how long they stay and how much their operations improve. That alignment changes everything about how we work—from how we staff your team to how we report results to how we handle the moments when something doesn't go perfectly.",
            icon: 'fas fa-bullseye',
        },
    ]
    return (
        <div className="three-pillar-strip td-section td-section--pillars rts-section-gap about-philosophy">
            <div className="container">
                <div className="td-section-head text-center mb-5">
                    <p className="td-section-label">Our Philosophy</p>
                    <h2 className="td-section-title">The Principles We Actually Run On</h2>
                    <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                </div>
                <div className="row g-4 g-lg-4 justify-content-center">
                    {pillars.map((pillar, i) => (
                        <div key={i} className="col-lg-4 col-md-12">
                            <div className="pillar-card">
                                <div className="pillar-card__header">
                                    <div className="pillar-icon" aria-hidden="true">
                                        <i className={pillar.icon} />
                                    </div>
                                    <div className="pillar-card__head-main">
                                        <div className="pillar-heading">
                                            <span className="pillar-number">{String(i + 1).padStart(2, '0')}</span>
                                            <h3 className="pillar-title">{pillar.title}</h3>
                                        </div>
                                    </div>
                                </div>
                                <p className="pillar-text">{pillar.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AboutPhilosophyStrip
